import { JOBS_URL } from '@/utils/constants'

const SERVICES = () => JOBS_URL
const SERVICE_BY_ID = (id: string) => `${JOBS_URL}/${id}`
const SERVICES_TASKS = () => `${JOBS_URL}/tasks`

export default {
  SERVICES,
  SERVICE_BY_ID,
  SERVICES_TASKS
}
